import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-trophy',
  templateUrl: './icon-trophy.component.html',
  styleUrls: ['./icon-trophy.component.scss']
})
export class IconTrophyComponent implements OnInit {
  @Input() color: string = 'rgb(208, 208, 208)';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
